<template>
  <fragment>
    <b-form-group>
      <b-form-radio-group
        id="type-of-file-input"
        v-model="isTextInput"
        :options="inputTypeOptions"
        name="type-of-file-input-radio-options"
        @change="onInputTypeChange"
      />
    </b-form-group>
    <b-form-group
      v-if="isTextInput"
      horizontal
      label-cols="3"
      label="File name:"
      label-class="font-weight-bold"
    >
      <b-form-input
        type="text"
        placeholder="Enter file name"
        :value="logoNameInput"
        @input="$emit('input-logo-name', $event)"
      />
    </b-form-group>
    <b-form-group
      v-else
      horizontal
      label-cols="3"
      :invalid-feedback="logoFileInvalidFeedback"
      label="Logo File:"
      label-class="font-weight-bold"
    >
      <b-form-file
        :value="logFileInput"
        @input="$emit('input-logo-file', $event)"
        @change="$emit('change-logo-file', $event)"
        :state="logoFileState"
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
        accept="image/*"
      />
      <div class="mt-3">Selected file: {{ logoFile ? logoFile.name : '' }}</div>
    </b-form-group>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-center">
        <society-logo :logo-file="logoSrc" />
      </b-col>
    </b-row>
  </fragment>
</template>

<script>
import SocietyLogo from '@/components/society/SocietyLogo';

export default {
  name: 'SocietyLogoInput',
  props: [
    'logFileInput',
    'logoNameInput',
    'logoFileState',
    'logoSrc',
    'logoFile',
    'logoFileInvalidFeedback',
  ],
  components: {
    SocietyLogo,
  },
  data: function () {
    return {
      isTextInput: Boolean(this.logoNameInput),
    };
  },
  computed: {
    inputTypeOptions: function () {
      return [
        { text: 'Browse', value: false },
        { text: 'Manually enter file name', value: true },
      ];
    },
  },
  methods: {
    onInputTypeChange: function (value) {
      if (value === true) {
        this.$emit('input-logo-file', '');
      } else {
        this.$emit('input-logo-name', '');
      }
    },
  },
};
</script>

<style scoped></style>
